import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

export interface NotifyNotification {
    message: SnackbarMessage;
    options?: OptionsObject;
    key?: SnackbarKey;
}

export const enqueueSnackbarAction = (notification: NotifyNotification) => {
    const key = notification.options && notification.options.key;

    return {
        type: ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random(),
        },
    };
};

export const closeSnackbarAction = (key: SnackbarKey) => ({
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
});

export const removeSnackbarAction = (key: SnackbarKey) => ({
    type: REMOVE_SNACKBAR,
    key,
});
